import { jsx as _jsx } from "react/jsx-runtime";
import { QuestionCircleOutlined } from '@ant-design/icons';
import { SelectLang as UmiSelectLang } from '@umijs/max';
export const SelectLang = () => {
    return (_jsx(UmiSelectLang, { style: {
            padding: 4,
        } }));
};
export const Question = () => {
    return (_jsx("a", { href: "https://pro.ant.design/docs/getting-started", target: "_blank", rel: "noreferrer", style: {
            display: 'inline-flex',
            padding: '4px',
            fontSize: '18px',
            color: 'inherit',
        }, children: _jsx(QuestionCircleOutlined, {}) }));
};
